import { VFC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Mounting } from '@enmon/commons';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { mountingTranslated } from '../../../Form/meter_details/constants';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface MountingSelectProps {
  value?: Mounting;
  onChange?: (value: Mounting) => void;
}

export const MountingSelect: VFC<MountingSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const mountingOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(Mounting),
        suggestedValue: meterModelSuggestions?.mounting?.value,
        suggestedSelection: meterModelSuggestions?.mounting?.selection,
        labelFormatter: (value: Mounting) => intl.formatMessage(mountingTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={mountingOptions}
      placeholder={<FormattedMessage {...messages.mounting} />}
      {...restProps}
    />
  );
};
